import { RadioButtonWithLabelOption } from '@tableau/widgets';
import * as React from 'react';

import { FeatureFlags } from '~src/ts/FeatureFlags';

import { Messages } from '../../../../codegen/Localize';
import { FormikRadioButtonGroup } from '../../../../commonInfra/components/FormikRadioButtonGroup';
import { SettingsSection } from '../../../components/common/SettingsSection';
import { settingsRadioButtonItemHeight } from '../../../styles/CommonStyles';
import { componentRegistryEntry } from '../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../site-settings/ReactSiteSettingsForSiteAdmin';

export const EXPLAIN_DATA_SECTION_TEST_ID = 'explain-data-site-setting';
export const EXPLAIN_DATA_MODE_ENABLED_BUTTON_TEST_ID = 'explain-data-mode-enabled';
export const EXPLAIN_DATA_MODE_DISABLED_BUTTON_TEST_ID = 'explain-data-mode-disabled';


export type ExplainDataSectionProps = SiteSettingsForSiteAdminProps<'explainDataEnabled'>;

export function ExplainDataSection() {

    const buttonList = React.useMemo(() => getButtonListAndClassName(), []);

    if (!FeatureFlags.explainDataSiteControl){
        return null;
      }

  return (
    <SettingsSection
      title={Messages.explainDataSiteSettingTitle()}
      description={<span>
          {Messages.explainDataSettingDescription()}
          </span>}
      testId={EXPLAIN_DATA_SECTION_TEST_ID}
    >
      <FormikRadioButtonGroup
        aria-label={Messages.explainDataSiteSettingTitle()}
        buttonList={buttonList}
        className={settingsRadioButtonItemHeight}
        name={'settings.explainDataEnabled'}
      />
    </SettingsSection>
  );
}


function getButtonListAndClassName(): RadioButtonWithLabelOption<boolean>[] {

  const explainDataEnabledButtonLabel = <>
    <div>{Messages.explainDataEnabledButton()}</div>
  </>;
  const explainDataDisabledButtonLabel = <>
    <div>{Messages.explainDataDisabledButton()}</div>
  </>;

  return[
    {
      value: true,
      label: explainDataEnabledButtonLabel,
      testId: EXPLAIN_DATA_MODE_ENABLED_BUTTON_TEST_ID
    },
    {
      value: false,
      label: explainDataDisabledButtonLabel,
      testId: EXPLAIN_DATA_MODE_DISABLED_BUTTON_TEST_ID
    }
  ];
}

/* for registering the component in settings registry */
export const ExplainDataSectionSpecs = componentRegistryEntry({
  name: 'ExplainDataSection',
  component: ExplainDataSection
});
